import React, { useEffect } from 'react';
import { modelsConsWrapper } from "../wrappers/modelsConsWrapper";
import Loading from "../shared/wait/Loading";
import DisplayVespas from "./vespas/DisplayVespas";
import DisplayModels from "./vespas/DisplayModels";
import useRentals from "../../hooks/useRentals";

const Vespas = ({ models, refreshModels }) => {
  const { rentals, refreshRentals, isLoading: isLoadingRentals } = useRentals()

  useEffect(() => {
    !models && refreshModels();
    // eslint-disable-next-line
  }, [])


  if (models === null) {
    return <Loading text="Cargando modelos..."/>
  }
  if (isLoadingRentals) {
    return <Loading text="Cargando vespas..."/>
  }
  return <React.Fragment>
    <DisplayModels models={models} updateModels={refreshModels} updateRentals={refreshRentals}/>
    <DisplayVespas rentals={rentals} models={models} updateRentals={refreshRentals}
                   updateModels={refreshModels}/>
  </React.Fragment>
}

export default modelsConsWrapper(Vespas);
